import React, { useContext, useEffect, useState } from "react";
import { PortalContext } from "../../../context/Provider";
import { getStrDate } from "../../../../global/utils/diasData";
import { showModal, hideModal } from "../../../context/Actions/modal/modal";
import IconBlack from "../../../assets/images/generico/IconBack";
import HeaderTimer from "../../Genericos/HeaderTimer/HeaderTimer";
import DatePicker from "../../Genericos/DatePicker/DatePicker";
import DropdownCheck from "../../Genericos/DropdownCheck/DropdownCheck";
import ConsultaIcon from "../../../assets/images/generico/ConsultaIcon";
import ViewIcon from "../../../assets/images/generico/ViewIcon";
import EtiquetaGrupoModal from "../EtiquetaGrupoModal/EtiquetaGrupoModal";
import camelize from "../../../../global/utils/camelize";
import "./HeaderBarFiltros.css";
import isIosNative from "../../../../global/utils/isIosNative";
import { HeaderBarFiltrosContainer } from "./localStyle";

const HeaderBarFiltros = ({
  handleClickVolver,
  handleChangeDatePicker,
  fecha,
  handleChangeCentros,
  handleChangeDia,
  handleChangeRango,
  handleChangeEspecialista,
  turnosData,
  filtrosData,
  nameTurnosDisponiblesParticular,
}) => {
  const { modalDispatch, turnosDisponiblesState } = useContext(PortalContext);

  const [descEspecialidad, setDescEspecialidad] = useState(false);
  const [grupoMedicoOk, setGrupoMedicoOk] = useState(false);
  const [agrupaEtiqueta, setAgrupaEtiqueta] = useState(false);
  const [centrosInicial, setCentrosInicial] = useState(1);
  const [especialistasInicial, setEspecialistasInicial] = useState(1);

  const dissmiss = () => {
    hideModal()(modalDispatch);
  };

  const onClickShowDeterminaciones = () => {
    showModal(
      "Genericos/Mensaje/Mensaje",
      {
        titulo: "Tus turnos agregados",
        texto: <EtiquetaGrupoModal />,
        dissmiss: dissmiss,
      },
      [
        {
          text: "Continuar",
          clase: "btn-Mensaje-1 bgc-black10 cursor:pointer rb18m c-white",
          accion: dissmiss,
        },
      ],
      "centro"
    )(modalDispatch);
  };

  useEffect(() => {
    if (
      turnosDisponiblesState.turnosDisponibles.turnosData.volverOrigen !==
      "LABORATORIO"
    ) {
      if (turnosData !== null) {
        if (turnosData.length > 0) {
          let centro = [...new Set(turnosData.map((item) => item.centro))];
          const map = new Map();
          for (const item of centro) {
            if (
              !filtrosData.centros.filter((x) => x.descripcion === item)
                .length > 0
            ) {
              if (!map.has(item)) {
                map.set(item);
                //para colocar correctamente los id. tomo el ultimo item de la lista. cuyo id + 1.
                const lastItem =
                  filtrosData.centros[filtrosData.centros.length - 1];
                filtrosData.centros.push({
                  id: lastItem.id + 1,
                  descripcion: item,
                  checked: false,
                });
              }
              if (filtrosData.centros.length >= 2) {
                setCentrosInicial(filtrosData.centros.length - 1);
              }
            }
          }
        } else if (turnosData.length === 0 && filtrosData.centros.length < 2) {
          setCentrosInicial(0);
        }
      }
    }
  }, [turnosData]);

  useEffect(() => {
    if (turnosData !== null) {
      if (turnosData?.length > 0) {
        let especialistas = [
          ...new Set(
            turnosData.map((item) =>
              item.medico !== null ? item.medico : item.recepcion
            )
          ),
        ];
        const map = new Map();
        for (const item of especialistas) {
          if (
            !filtrosData.especialistas.filter(
              (x) => camelize(x.descripcion) === camelize(item)
            ).length > 0
          ) {
            if (!map.has(item)) {
              map.set(item);
              const lastItem =
                filtrosData.especialistas[filtrosData.especialistas.length - 1];
              filtrosData.especialistas.push({
                id: lastItem.id + 1,
                descripcion: camelize(item),
                checked: false,
              });
            }
            if (filtrosData.especialistas.length >= 2) {
              setEspecialistasInicial(filtrosData.especialistas.length - 1);
            }
          }
        }
      } else if (
        turnosData.length === 0 &&
        filtrosData.especialistas.length < 2
      ) {
        setEspecialistasInicial(0);
      }
    }
  }, [turnosData]);

  useEffect(() => {
    if (
      turnosDisponiblesState.turnosDisponibles.turnosData.descEspecialidad !==
        "" &&
      turnosDisponiblesState.turnosDisponibles.turnosData.descEspecialidad !==
        null
    ) {
      setDescEspecialidad(true);
    }
    if (
      turnosDisponiblesState.turnosDisponibles.turnosData.grupoMedico !==
        null ||
      turnosDisponiblesState?.turnosDisponibles?.turnosData?.GruposMedico !==
        null
    ) {
      setGrupoMedicoOk(true);
      if (
        turnosDisponiblesState?.turnosDisponibles?.turnosData?.grupoMedico
          ?.length > 1 ||
        turnosDisponiblesState?.turnosDisponibles?.turnosData?.GruposMedico
          ?.length > 1
      ) {
        setAgrupaEtiqueta(true);
      }
    }
  }, []);

  const noventaDiasDespues = new Date(fecha);
  noventaDiasDespues.setDate(noventaDiasDespues.getDate() + 90);
  const diaSelecionado =
    turnosDisponiblesState.turnosDisponibles.turnosData.fechaSeleccionada;
  const [iosInfo, setIosInfo] = useState(false);
  async function infoIos() {
    const isIosNativeMobile = await isIosNative.logDeviceInfo();
    setIosInfo(isIosNativeMobile);
    return isIosNativeMobile;
  }
  infoIos();
  return (
    <React.Fragment>
      <HeaderBarFiltrosContainer className="c-white" $isIos={iosInfo}>
        <div className="ptur-headerbarFiltros-volverBox">
          <button
            className="ptur-headerbarFiltros-volverBtn"
            onClick={handleClickVolver}
          >
            <IconBlack />
            <span className="ptur-headerbarFiltros-volverTxt rb18m">
              VOLVER
            </span>
          </button>
        </div>
        <div className="ptur-headerBarFiltros-filtros c-white">
          <div className="ptur-headerBarFiltros-filtros-title">
            <span className="rb18m">Filtros:</span>
          </div>

          <div className="ptur-headerBarFiltros-filtros-centro c-black">
            <DropdownCheck
              customWh={"ptur-headerBarFiltros-centroCheck-box"}
              boxCheckArrowed={false}
              handleChangeFiltros={handleChangeCentros}
              placeholder={"Centros"}
              longitud={
                turnosDisponiblesState.turnosDisponibles.turnosData
                  .volverOrigen === "LABORATORIO"
                  ? turnosDisponiblesState.turnosDisponibles.turnosData
                      .filtrosData.centrosLabo.length - 1
                  : centrosInicial
              }
              datos={
                turnosDisponiblesState.turnosDisponibles.turnosData
                  .volverOrigen === "LABORATORIO"
                  ? filtrosData?.centrosLabo
                  : filtrosData?.centros
              }
            />
          </div>
          <div className="ptur-headerBarFiltros-filtros-fecha c-black">
            <DatePicker
              fechaInicial={`${fecha.getFullYear()} ${
                fecha.getMonth() + 1
              } ${fecha.getDate()}`}
              selectedFecha={`${!diaSelecionado ? "" : diaSelecionado}`}
              fechaFinal={`${noventaDiasDespues.getFullYear()} ${
                noventaDiasDespues.getMonth() + 1
              } ${noventaDiasDespues.getDate()}`}
              onChange={handleChangeDatePicker}
              customCss={"ptur-headerBarFiltros-filtros-datePicker"}
            />
          </div>
          <div className="ptur-headerBarFiltros-filtros-dia c-black">
            <DropdownCheck
              customWh={"ptur-headerBarFiltros-diaCheck-box"}
              boxCheckArrowed={false}
              placeholder={"Día semanal"}
              longitud={filtrosData?.diasKin.length - 1}
              datos={filtrosData?.diasKin}
              handleChangeFiltros={handleChangeDia}
            />
          </div>
          <div className="ptur-headerBarFiltros-filtros-hora c-black">
            <DropdownCheck
              customWh={"ptur-headerBarFiltros-rangoCheck-box"}
              boxCheckArrowed={false}
              placeholder={"Horarios"}
              longitud={filtrosData?.rangoHorario.length - 1}
              datos={filtrosData?.rangoHorario}
              handleChangeFiltros={handleChangeRango}
            />
          </div>
          {turnosDisponiblesState.turnosDisponibles.turnosData?.grupoMedico !==
            null ||
          turnosDisponiblesState?.turnosDisponibles?.turnosData
            ?.GruposMedico !== null ||
          (turnosDisponiblesState?.turnosDisponibles?.turnosData
            ?.GruposMedico !== null &&
            turnosDisponiblesState?.turnosDisponibles?.turnosData
              ?.GruposMedico !== undefined) ? (
            <div className="ptur-headerBarFiltros-filtros-especialista c-black">
              <DropdownCheck
                customWh={"ptur-headerBarFiltros-espCheck-box"}
                boxCheckArrowed={false}
                placeholder={"Especialistas"}
                longitud={especialistasInicial}
                datos={filtrosData?.especialistas}
                handleChangeFiltros={handleChangeEspecialista}
              />
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="ptur-headerBarFiltros-etiquetaTurno">
          <ConsultaIcon color={"var(--color-white)"} />
          {turnosDisponiblesState.turnosDisponibles.particular ? (
            <span className="ptur-headerBarFiltros-descParticular c-white rb14b">
              PARTICULAR:
            </span>
          ) : (
            <span className="nameTurnosDisponiblesParticular">
              {nameTurnosDisponiblesParticular}
            </span>
          )}
          <span className="ptur-headerBarFiltros-etiquetaTurnoDesc c-white rb14l">
            {grupoMedicoOk ? (
              agrupaEtiqueta ? (
                <button
                  onClick={() => onClickShowDeterminaciones()}
                  className="ptur-headerBarFiltros-btnTurno c-white"
                >
                  VER ESTUDIOS AGREGADOS
                  <span className="ptur-headerBarFiltros-viewIcon">
                    <ViewIcon />
                  </span>
                </button>
              ) : descEspecialidad ? (
                turnosDisponiblesState.turnosDisponibles.turnosData
                  .descEspecialidad
              ) : (
                turnosDisponiblesState.turnosDisponibles.turnosData.descEstudio
              )
            ) : descEspecialidad ? (
              turnosDisponiblesState.turnosDisponibles.turnosData
                .descEspecialidad
            ) : (
              turnosDisponiblesState.turnosDisponibles.turnosData.descEstudio
            )}
          </span>
        </div>
        <div className="ptur-headerBarFiltros-txtDiaHora">
          <p id="ptur-DiaResponsive" className="rb18m">
            {getStrDate(new Date())}
            <span className="ptur-timer">
              <HeaderTimer />
            </span>
          </p>
        </div>
      </HeaderBarFiltrosContainer>
    </React.Fragment>
  );
};

export default HeaderBarFiltros;
